import React from "react";
import { noHandler } from "@/components/ReactRangePicker/utils";

import "./index.scss";

const MonthPicker = ({
  months = [],
  disabled = -1,
  selected = -1,
  visible = false,
  onChange = noHandler(" no change handler for month change"),
}) => {
  return (
    <div className={`month-select${visible ? " visible" : " hidden"}`}>
      <div className="select-items">
        {months.map((month, index) => {
          const onClick = index !== disabled ? onChange : () => {};
          return (
            <div
              key={index}
              className={`select-item${index === disabled ? " disabled" : ""}${
                index === selected ? " selected" : ""
              }   btn btn-outline ripple`}
              onClick={(event) => {
                onClick(month, index);
                event.preventDefault(); // 阻止表单提交的默认行为
                event.stopPropagation(); // 阻止事件冒泡
              }}
            >
              {" "}
              {month}{" "}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MonthPicker;
